module.exports = "https://web-assets.ifttt.com/packs/media/icons/heavy-rain-7be7e61f.png";